import { z } from 'zod';

/**
 * Telefonla kimlik tarama eslesmesi ("tarayici").
 *
 * Resepsiyon masasindaki bilgisayarda kamera ya yoktur ya da kotudur;
 * gorevlinin telefonu ise her zaman cebindedir. Bu eslesme, telefonu
 * masanin KAMERASI yapar - baska hicbir sey yapmaz:
 *
 *   - Telefon check-in'i TAMAMLAYAMAZ. KBS bildirimi, oda ve ucret onayi
 *     masada kalir. Boylece yasal sorumlulugu tasiyan ekran tektir ve
 *     telefon kaybolsa/ele gecse bile konaklama acilamaz.
 *   - Eslesme ISTEGE BAGLIDIR. Gorevli "Telefonla tara" demedikce hicbir
 *     kanal acilmaz; masa kapaninca eslesme de olur.
 *   - Eslesme kodu TEK KULLANIMLIKTIR ve 60 saniye yasar. QR ekranda asili
 *     kalsa bile ikinci bir telefon baglanamaz.
 *   - Telefonun kendisi de personel oturumu ister; QR tek basina yetki vermez.
 */

/** Eslesme kodu: karistirilabilir harf/rakam (0/O, 1/I) disarida. */
export const ESLESME_ALFABE = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const ESLESME_KOD_UZUNLUK = 8;
/** QR ekranda ne kadar gecerli kalir. Kisa: omuz ustunden okunmasi ise yaramasin. */
export const ESLESME_KOD_OMRU_MS = 60_000;
/** Eslesme kurulduktan sonraki toplam omur - bir check-in'e fazlasiyla yeter. */
export const ESLESME_OMRU_MS = 15 * 60_000;

export const eslesmeKodSchema = z
  .string()
  .trim()
  .toUpperCase()
  .length(ESLESME_KOD_UZUNLUK)
  .regex(new RegExp(`^[${ESLESME_ALFABE}]+$`), 'Kod geçersiz');

/** Masa eslesmeyi acar. Telefon ekraninda gosterilecek baglam da buradadir. */
export const tarayiciAcSchema = z.object({
  reservationId: z.string().min(1),
  rezKodu: z.string().trim().min(1).max(40),
  odaNo: z.string().trim().max(10).nullable().optional(),
  kisiSayisi: z.number().int().min(1).max(20),
  sira: z.number().int().min(0).max(19),
});
export type TarayiciAc = z.infer<typeof tarayiciAcSchema>;

/** Telefon QR'daki kodla baglanir. */
export const tarayiciEslestirSchema = z.object({ kod: eslesmeKodSchema });

/** Masa sirayi degistirince telefon "2. kişi" yazsin. */
export const tarayiciSiraSchema = z.object({ sira: z.number().int().min(0).max(19) });

/**
 * Telefonun masaya birakabildigi TEK sey: okunmus kimlik alanlari.
 * Yuk serbest bicimdedir (IdentityOcrResult) ama hangi kisiye ait oldugu
 * ZORUNLUDUR; yoksa uc kisilik bir konaklamada yanlis kisiye yazilir.
 */
export const tarayiciKimlikSchema = z.object({
  sira: z.number().int().min(0).max(19),
  ocr: z.unknown(),
});

/** Telefonun gordugu baglam. Oda plani ya da misafir listesi ICERMEZ. */
export interface TarayiciBaglam {
  eslesmeId: string;
  rezKodu: string;
  odaNo: string | null;
  kisiSayisi: number;
  sira: number;
  sonKullanma: number;
  /** Masa hala acik mi; kapandiysa telefon ekrani kendini kilitler. */
  acik: boolean;
}
